import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { AUTEST_REMOTE_SERVER } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
import {doubleEncode} from "../../../../Utils/Encode/UrlHelper";
/**
 * list Remote Servers.
 * @returns {Promise} - A promise that resolves with the list of Remote Servers or rejects with an error.
 * @param props
 */
export const listRemoteServer = async ({
  accessToken,
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };

  const response = await apiServiceWrapper({
    url: `${AUTEST_REMOTE_SERVER}/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    remoteServer: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Remote Server.
 * @returns {Promise} - A promise that resolves with the creation of Remote Server or rejects with an error.
 * @param data
 */
export const createRemoteServer = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_REMOTE_SERVER}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Remote Server.
 * @returns {Promise} - A promise that resolves with the update of Remote Server or rejects with an error.
 * @param data
 */
export const updateRemoteServer = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_REMOTE_SERVER}/${data?.tenant_id}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete Remote Server.
 * @returns {Promise} - A promise that resolves with the update of Remote Server or rejects with an error.
 * @param data
 */
export const deleteRemoteServer = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_REMOTE_SERVER}/${doubleEncode(data?.tenant_id)}?envId=${encodeURIComponent(data?.uc_env_id)}&tenantid=${encodeURIComponent(data?.tenant_id)}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};
